import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Bell, Check } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/lib/auth";

export function NotificationsBell() {
  const { user } = useAuth();
  const [data, setData] = useState({items: [], unread: 0});
  const [open, setOpen] = useState(false);

  const load = () => {
    if (!user) return;
    api.get("/notifications").then(r=>setData(r.data)).catch(()=>{});
  };
  useEffect(()=>{
    load();
    if (!user) return;
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, [user?.id]);

  const readAll = async () => {
    await api.post("/notifications/read-all");
    load();
  };

  if (!user) return null;

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button data-testid="notif-bell" className="relative p-2 rounded-full hover:bg-slate-100">
          <Bell className="w-5 h-5 text-slate-700"/>
          {data.unread>0 && <span data-testid="notif-unread" className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] rounded-full bg-[#FF7D54] text-white text-[10px] font-bold flex items-center justify-center px-1">{data.unread}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0">
        <div className="flex items-center justify-between px-4 py-3 border-b">
          <div className="font-semibold">Notificações</div>
          {data.unread>0 && <Button size="sm" variant="ghost" data-testid="notif-mark-all" onClick={readAll}><Check className="w-4 h-4 mr-1"/>Marcar todas</Button>}
        </div>
        <div className="max-h-96 overflow-auto">
          {data.items.length === 0 && <div className="p-6 text-center text-sm text-slate-500">Sem notificações ainda.</div>}
          {data.items.map(n=>(
            <div key={n.id} data-testid={`notif-${n.id}`} className={`px-4 py-3 border-b last:border-b-0 ${!n.read?"bg-[#E6F4F1]/40":""}`}>
              <div className="text-sm font-semibold">{n.title}</div>
              <div className="text-xs text-slate-600 mt-0.5">{n.body}</div>
              <div className="text-[10px] text-slate-400 mt-1">{new Date(n.created_at).toLocaleString("pt-BR")}</div>
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
